import { t } from './i18n/index.js';

/** A SIP user that is a US number reads as one: +1 (415) 555-0132; a short one as an extension. */
export function number(user: string): string {
  const compact = user.replace(/[\s().-]/g, '');
  const digits = compact.replace(/^\+/, '');
  if (/^\+?\d+$/.test(compact) && (digits.length === 10 || (digits.length === 11 && digits.startsWith('1')))) {
    const n = digits.slice(-10);
    return `+1 (${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6)}`;
  }
  if (/^\d{2,6}$/.test(user)) return t('line.ext', { n: user });
  return user;
}

/** "Front desk" → "FD", for a line's plate. */
export function initials(name: string): string {
  return name.split(/\s+/).filter(Boolean).map((w) => w[0]).join('').slice(0, 2).toUpperCase() || '·';
}
